export default __webpack_public_path__ + "static/media/bg-big-menu.e258c790.jpg";